/** This file is auto generated by convertSvgToJsx.ts */

import icon from './dnb/id_card_medium'
export default icon
